import { put } from "sr/utils/axios";
import {toast} from 'react-toastify'
import ApiResponse from "sr/models/ApiResponse";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
export const updateCleaner = async (putData:any) => {

try {
 
    
return await put<ApiResponse<[]>>('/cleaner/', putData ).then((res)=> {
    if(res.success=== true) {
        return res
    }
    else {
        toast.error(res.error.message)
          return null
    }
})
}
catch(e:any) {
    HandleApiError(e);
    return null
}
}